import { render, staticRenderFns } from "./SortTabs.vue?vue&type=template&id=25b91524&"
import script from "./SortTabs.vue?vue&type=script&lang=ts&"
export * from "./SortTabs.vue?vue&type=script&lang=ts&"
import style0 from "./SortTabs.vue?vue&type=style&index=0&id=25b91524&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports